import { GET_LIST_SUCCESS } from '@/state/types/data'

export default (resource, options) => (previousState = 0, { type, payload, meta }) => {
  if (!meta || meta.resource !== resource) {
    return previousState
  }
  if (type === GET_LIST_SUCCESS) {
    return payload.total
    // return payload.data.total
  }
  return previousState
}



// WEBPACK FOOTER //
// ./state/reducers/resource/list/total.js